module.exports = __webpack_public_path__ + "img/category-sport-hover.7dc631ff.png";